
import { defineComponent } from "vue";

import TeachersContent from "./components/TeachersContent.vue";

export default defineComponent({
  name: "TeachersPage",
  components: {
    TeachersContent,
  },
});
